// Cart quantity controls functionality
$(document).ready(function() {
  // Helper function to sync the display input with the hidden main input
  function syncInputValue(displayInput) {
    const index = $(displayInput).data('item-index');
    const value = $(displayInput).val();
    
    // Update the hidden main input that will be submitted with the form
    $(`.cart__quantity-main[data-item-index="${index}"]`).val(value);
    
    // Sync any other display inputs for the same item (i.e., between mobile and desktop views)
    $(`.js-quantity-display[data-item-index="${index}"]`).not(displayInput).val(value);
  }
  
  // Quantity decrease buttons for both mobile and desktop variants
  $('.js-quantity-decrease').on('click', function() {
    const input = $(this).siblings('input[type="number"]');
    const currentValue = parseInt(input.val());
    
    if (currentValue > 1) {
      input.val(currentValue - 1).trigger('change');
    }
  });

  // Quantity increase buttons for both mobile and desktop variants
  $('.js-quantity-increase').on('click', function() {
    const input = $(this).siblings('input[type="number"]');
    const currentValue = parseInt(input.val());
    input.val(currentValue + 1).trigger('change');
  });

  // When display input changes, sync with hidden input and trigger update
  $('.js-quantity-display').on('change', function() {
    // Sync all inputs first
    syncInputValue(this);
    
    const $form = $(this).closest('form');
    
    // Delay to allow for multiple rapid clicks before submitting
    clearTimeout(window.cartUpdateTimeout);
    window.cartUpdateTimeout = setTimeout(function() {
      $form.find('button[name="update"]').click();
    }, 300);
  });

  // Terms and conditions checkbox (if present)
  $('#cart-terms-checkbox').on('change', function() {
    $('.cart__checkout').prop('disabled', !this.checked);
  });
});
